import React, { Fragment } from 'react';
import { LazyLoadImage } from "react-lazy-load-image-component";

const LazyLoadImageComponent = (props) => {
  const src = props.src;
  return (
    <Fragment>
      <LazyLoadImage
        {...props}
        src={src}
      />
    </Fragment>
  );
};

export default LazyLoadImageComponent;
